import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { combineLatest, map } from 'rxjs';
import { UserPermission } from '../../shared/constants/permission.constants.enum';
import { DowntimeService } from '../../shared/services/downtime.service';
import { UserService } from '../../shared/services/user.service';

export const downtimeGuard: CanActivateFn = () => {

  const downtime = inject(DowntimeService);
  const user = inject(UserService);
  const router = inject(Router);

  return combineLatest([downtime.downtime$, user.permission$]).pipe(
    map(([d, p]) => {
      const isAdmin = p.includes(UserPermission.ConQuest_ISAdmin) || p.includes(UserPermission.ConQuest_Quorum_ISAdmin);
      if (!isAdmin && !d.isDown) {
        return router.parseUrl('/');
      }
      return true;
    })
  );
};
